import React from 'react';
import Concept from 'components/Tvendo/Shopping/DataMaster/ConceptNC/Concept.js';

export default function () {
  return <Concept />;
}
